import { DeliveryMode } from '../common/constants';
import KollectiveXHR from '../interceptor/KollectiveXHR';
import addHlsBitrateTracker from './addHlsBitrateTracker';
import logger from '../log';

const log = logger.getLogger(__filename);

function validRequestOptions(options) {
  if (options && options.uri && options.xhr) {
    return options;
  } else {
    return null;
  }
}

/**
 * Bind intercept to vidoejs instance through hls tech.
 * see: https://github.com/videojs/http-streaming#hlsxhr
 * @param {{}} player videojs player instance
 * @param {{}} playerOptions options for the player instance player instance
 * @param {{}} binder the getOptions and shouldIntercept functions.
 * @returns {void}
 */
export default function bindVideoJsToWebRTC(player, playerOptions, binder) {
  const optionsBefore = playerOptions.beforeRequest;
  player.ready(function () {
    let previousBefore;
    const kBefore = function (options) {
      const opts = binder.getOptions() || {};
      log.trace('intercepting request', options);
      if (previousBefore) {
        const out = previousBefore(options);
        // in case the previous before call doesn't return the modified options.
        if (validRequestOptions(out)) {
          options = out;
        }
      }
      // Only set beforeReqest handler when we are not in 10 mode
      if (optionsBefore && opts.activeMode != DeliveryMode.ECDN10) {
        const out = optionsBefore(options);
        if (validRequestOptions(out)) {
          options = out;
        }
      }
      if (binder.shouldIntercept()) {
        options.xhr = new KollectiveXHR(opts);
      }

      return options;
    };

    // See https://github.com/videojs/video.js/issues/2617 for the reasoning around this parameter.
    const tech = player.tech({ IWillNotUseThisInPlugins: true });

    addHlsBitrateTracker(player, tech);

    // SRV-1440
    // We need to set the global beforeRequest handler so the master playlist gets captured.
    // This will only work if the videojs is available on the window.
    let previousGlobalBefore;
    const vjs = window.videojs;
    const Vhs = vjs && (vjs.Vhs || vjs.Hls);
    if (Vhs) {
      previousGlobalBefore = Vhs.xhr.beforeRequest;
      Vhs.xhr.beforeRequest = kBefore;
    }

    const interval = setInterval(() => {
      // for whatever reason, the tech isn't always available when the player is ready.
      // This interval validates the tech's state.
      const vhs = tech.vhs || tech.hls;
      if (vhs) {
        // Done with this interval.
        clearInterval(interval);
        // be like videojs - https://github.com/videojs/http-streaming/blob/e59428a0f16e6ff44f5a327a9fcc137a3c13d915/src/xhr.js#L30
        const { beforeRequest } = vhs.xhr;
        if (beforeRequest && typeof beforeRequest === 'function') {
          previousBefore = vhs.xhr.beforeRequest;
        }
        vhs.xhr.beforeRequest = kBefore;
        const Vhs = vjs && (vjs.Vhs || vjs.Hls);
        if (Vhs) {
          Vhs.xhr.beforeRequest = previousGlobalBefore;
        }
        // In case the user resets the source stream, this will listen for the handler to
        // be disposed and then restart the binding process.
        vhs.on('dispose', () => {
          bindVideoJsToWebRTC(player, playerOptions, binder);
        });
      }
    }, 2);
  });
}
